const samsConfig = __SAMS_CONFIG__;
const azConfig =  __AZ_CONFIG__;
const isLocalhost = typeof __IS_LOCALHOST__ !== 'undefined' && __IS_LOCALHOST__;

const basePath = {
    api: '/api',
    funcapp: '/funcapp',
    signalr: '/signalr',

    consensus: '/consensus',
    heartbeat: '/heartbeat',
    molecularReview: '/molecular/review',
    molecularInterpretation: '/molecular/interpretation',
    molecularLiterature: '/molecular/literature',
    molecularData: '/molecular/data',
    summary: '/summary',
    taskManagement: '/taskmanagement',
    datastore: '/datastore',
    auth: '/auth',
    admin: '/admin',
    user: '/user',
    workflows: '/workflow',
    validateVcf: '/validate-vcf',
    validateBiochemicalCsv: '/biochemical/validate-CSV',
    validateClinicalCsv: '/clinical/validate',
    molecularMetadata: '/molecular/metadata',
    biochemical: '/biochemical',
    biochemicalData: '/biochemical/data',
    biochemicalStatistic: '/biochemical/statistic',
    conditionsLookup: '/lookup/conditions',
    analytesLookup: '/lookup/analytes',
    explore: '/explore',
    lookup: '/lookup',
    negotiate: '/negotiate',
    programSetting: '/program-setting',
};

const Paths = {
    //  ====== SAMS ENDPOINTS ======
    samsAuth: samsConfig.authUrl + '?response_type=code&client_id=' + samsConfig.clientId +
        '&client_secret=' + samsConfig.clientSecret + '&redirect_uri=' + samsConfig.redirectUri + '&scope=openid profile email',
    samsToken: samsConfig.tokenUrl,
    samsUserInfo: samsConfig.userInfoUrl,
    //samsValidate: samsConfig.validateUrl,
    samsValidate: basePath.api + basePath.auth + '/validateToken',
    samsLogout: isLocalhost ? samsConfig.logoutUrlNoRedirect : samsConfig.logoutUrl,

    //  ====== ADMIN MANAGEMENT ENDPOINTS ======
    getProgram: basePath.api + basePath.admin + '/program/get/{programId}',
    getAllUsers: basePath.api + basePath.admin + '/user',
    getProgramUsers: basePath.api + basePath.admin + '/user/get/{programId}',
    createUser: basePath.api + basePath.admin + '/user/register',
    updateUser: basePath.api + basePath.admin + '/user/update',
    updateUserStatus: basePath.api + basePath.admin + '/user/updateStatus?userId={userId}',
    updateProgramSetting: basePath.api + basePath.admin + '/program/update/{programId}',

    //  ====== AUTH ENDPOINTS ======
    authValidate: basePath.api + basePath.auth + '/verify',

    //  ====== PROGRAM SETTING RESTRICTED CONDITION ENDPOINTS ======
    getRestrictedCondition: basePath.api + basePath.programSetting + '/get/restricted-condition/{programId}',
    updateRestrictedCondition: basePath.api + basePath.programSetting + '/update/restricted-condition/{programId}',

    //  ====== PROGRAM SETTING CUTOFF VALUES ENDPOINTS ======
    getCutoffValues: basePath.api + basePath.programSetting + '/get/cutoffvalues/{programId}',
    updateCutoffValues: basePath.api + basePath.programSetting + '/update/cutoffvalues/{programId}',
    validateCutoffImport: basePath.api + basePath.programSetting + '/validate-cutoff?programId={programId}',

    //  ====== PROGRAM SETTING HISTORY (AUDIT) ENDPOINTS ======
    getProgramSettingHistory: basePath.api + basePath.programSetting + '/history/{programId}',

    //  ====== PROGRAM SUMMARY ENDPOINTS ======
    getPatientSummaryByProgramId: basePath.api + basePath.summary + '/patient/{programId}',
    getVariantSummaryByProgramId: basePath.api + basePath.summary + '/variant/{programId}',

    // ====== USER ENDPOINTS ======
    userHgvsColumns: basePath.api + basePath.user + '/hgvscolumns',
    getUser: basePath.api + basePath.user + '/{id}?includeUserRole=true',

    getVariantSummaryByProgramPatientId: basePath.api + basePath.summary + '/variant/{programId}/{patientId}',

    //  ====== EXPLORE ENDPOINTS ======
    getBiochemicalScatterplotAxisOptions: basePath.api + basePath.explore + '/lookup/scatterplotAxisOptions',
    getBiochemicalPrograms: basePath.api + basePath.explore + '/lookup/programs',
    getBiochemicalAnalytes: basePath.api + basePath.explore + '/lookup/analytes',
    getConditionsLookup: basePath.api + basePath.conditionsLookup,
    getAnalytesLookup: basePath.api + basePath.analytesLookup,
    searchVariant: basePath.api + basePath.explore + '/search/variant/{programId}',
    searchGenotype: basePath.api + basePath.explore + '/search/genotype/{programId}',

    //  ====== BIOCHEMICAL ENDPOINTS ======
    getBiochemicalByProgramPatientId: basePath.api + basePath.biochemicalData + '/{programId}/{patientId}/{testId}',
    biochemicalScatterplot: basePath.api + basePath.biochemical + '/scatterplot',
    biochemicalHistogram: basePath.api + basePath.biochemical + '/histogram',

    //  ====== BIOCHEMICAL STATISTICS ENDPOINTS ======
    getBiochemicalStatistics: basePath.api + basePath.biochemicalStatistic,

    //  ====== BIOCHEMICAL FILE ENDPOINTS ======
    biochemicalFileUpload: basePath.funcapp + azConfig.azUploadBiochemical + azConfig.funcAppKey,

    //  ====== MOLECULAR FILE ENDPOINTS ======
    molecularFileUpload: basePath.funcapp + azConfig.azUploadMolecular + azConfig.funcAppKey,

    //  ====== CLINICAL FILE ENDPOINTS ======
    clinicalFileUpload: basePath.funcapp + azConfig.azUploadClinical + azConfig.funcAppKey,

    //  ====== SIGNALR ENDPOINTS ======
    signalRnegotiateUrl: basePath.funcapp + basePath.negotiate + azConfig.funcAppKey,

    //  ====== MOLECULAR REVIEW ENDPOINTS ======
    molecularGetReview: basePath.api + basePath.molecularReview + '/{programId}/{variantId}',
    molecularGetProgramActivity: basePath.api + basePath.molecularReview + '/programActivity/{programId}/{variantId}',
    molecularUpdateReviewSetting: basePath.api + basePath.molecularReview + '/update/{variantReviewId}',
    molecularDeleteReview: basePath.api + basePath.molecularReview + '/delete',
    molecularCreateReview: basePath.api + basePath.molecularReview + '/create',
    molecularReopenReview: basePath.api + basePath.molecularReview + '/reopen',

    //  ====== MOLECULAR INTERPRETATION ENDPOINTS ======
    molecularAddVariantInterpretation: basePath.api + basePath.molecularInterpretation + '/add/{programId}/{variantId}',
    molecularUpdateVariantInterpretation: basePath.api + basePath.molecularInterpretation + '/update/{programId}/{variantId}',
    molecularGetInterpretationsAssignedToUser: basePath.api + basePath.molecularInterpretation + '/get/{userId}',
    molecularGetInterpretationsByReview: basePath.api + basePath.molecularInterpretation + '/getbyreview/{variantReviewId}',
    molecularGetInterpretation: basePath.api + basePath.molecularInterpretation + '/get/{programId}/{userId}/{variantId}',
    molecularGetFormattedFinalVariantInterpretations: basePath.api + basePath.molecularInterpretation + '/final/get/{variantId}',
    molecularAssignVariantInterpretation: basePath.api + basePath.molecularInterpretation + '/assign/user/{variantReviewId}',
    molecularUnassignVariantInterpretation: basePath.api + basePath.molecularInterpretation + '/unassign/user/{variantReviewId}',

    //  ====== MOLECULAR CONSENSUS ENDPOINTS
    molecularGetConsensusSummary: basePath.api + basePath.consensus + '/get/{programId}/{variantId}',

    //  ====== MOLECULAR LITERATURE ENDPOINTS ======
    molecularSearchLiterature: basePath.api + basePath.molecularLiterature + '/search/{variantId}',
    molecularGetLiteratureReviews: basePath.api + basePath.molecularLiterature + '/get/{variantInterpretationId}',
    molecularSaveLiteratureReviews: basePath.api + basePath.molecularLiterature + '/add/{variantInterpretationId}',
    molecularSaveFinalConsensusLiteratureReviews: basePath.api + basePath.molecularLiterature + '/update/final',
    molecularDeleteLiteratureReview: basePath.api + basePath.molecularLiterature + '/delete/{variantInterpretationId}/{pmid}',
    molecularGetLiteratureCategories: basePath.api + basePath.molecularLiterature + '/categories',

    // ====== MOLECULAR METADATA ENDPOINTS =====
    molecularGetMetadata: basePath.api + basePath.molecularMetadata + '/get/{fieldName}',

    //  ====== WORKFLOW ENDPOINTS ======
    validateVCFFile: basePath.api + basePath.molecularData + basePath.validateVcf + '?programId={programId}',
    validateBiochemicalCSVFile: basePath.api + basePath.validateBiochemicalCsv + '?programId={programId}',
    validateClinicalFile: basePath.api + basePath.validateClinicalCsv + '?programId={programId}',
    getAvailableWorkflows: basePath.api + basePath.workflows + '/get',
    getWorkflowByProgramId: basePath.api + basePath.workflows + '/runs/get/{programId}',
    getWorkflowStepsByWorkflowRunId: basePath.api + basePath.workflows + '/runs/get/workflowstep/{workflowRunId}',

    //  ====== DATASTORE ENDPOINTS ======
    datastoreGetVariant: basePath.api + basePath.datastore + '/variant?variantId={variantId}',
    datastoreGetAnnotations: basePath.api + basePath.datastore + '/annotation?variantId={variantId}',
    datastoreGetFieldDescriptions: basePath.api + basePath.datastore + '/fieldDescription',
    datastoreGetHgvsNames: basePath.api + basePath.datastore + '/hgvsNames?variantObjectid={variantId}',

    //  ====== TASK MANAGEMENT ENDPOINTS ======
    alert: basePath.api + basePath.taskManagement + '/alert/get',  
    
    // ====== LOOKUP ENDPOINTS ======
    lookupPrograms: basePath.api + basePath.lookup + '/programs',
    lookupRoles: basePath.api + basePath.lookup + '/roles',
    lookupGenes: basePath.api + basePath.lookup + '/genes',

    // ====== TAG ENDPOINTS ======
    getTags: basePath.api + '/tags',
};

export default Paths;
